export default __webpack_public_path__ + "static/media/overview 2.d5812924.svg";